import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import API from 'api';

export const useDownloadDocumentMutation = (
  options?: UseMutationOptions<void, AxiosError, { blockchainAddress: string; title: string }>
) =>
  useMutation<void, AxiosError, { blockchainAddress: string; title: string }>(
    async ({ blockchainAddress, title }) => {
      const fileContent = await API.documents.getDocumentsIDFile(blockchainAddress);

      const url = window.URL.createObjectURL(new Blob([fileContent], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(() => URL.revokeObjectURL(link.href));
    },
    options
  );

export default useDownloadDocumentMutation;
